import request from '@/utils/request'

export function queryCustomerAnalysisOverview(data) {
  return request({
    url: '/crmCustomerAnalysis/overview',
    method: 'post',
    data
  })
}

export function listCustomerAnalysis(data) {
  return request({
    url: '/crmCustomerAnalysis/list',
    method: 'post',
    data
  })
}

export function queryCustomerAnalysisDetail(query) {
  return request({
    url: '/crmCustomerAnalysis/detail',
    method: 'get',
    params: query
  })
}
